import { PageLoadingIndicator } from '@wrisk/ui-components'
import React, { FunctionComponent, PropsWithChildren } from 'react'

import { useApiErrorHandlingAsync } from '../../hooks/auth'
import { usePrincipal } from '../authentication'

export const RefreshAnonymous: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const principal = usePrincipal()

  const refreshAnonymous = useApiErrorHandlingAsync(async () => {
    if (!principal.isAuthenticated) {
      await principal.refresh()
    }
  }, [])

  return refreshAnonymous.loading ? <PageLoadingIndicator /> : children
}
